import setCurrentPage from "src/Utils/setCurrentPage";

const DATA_BO_DEMO_ILO1 = {
  title: "Milestone view",
  subtitle: "Business Operations Demo",
  text: '<span style="font-weight:bold">Observability</span> — Reducing operational\nexpenditure (OPEX) by providing visibility on\nwhat is pending or has been achieved.',
  label: { iconPath: "start.png", text: "Milestone Job" },
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ILO_109"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_107"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/ILO1/ILO1_demo_screens_base.png",
  rightSideVideo: "ILO/ILO1/INF_CMT_827.23_Business Demo_Part 5_R1.mp4",
  pageNumber: "ILO_108",
};

export default DATA_BO_DEMO_ILO1;
